export class TweakwiseFilterSearch {
    constructor(searchField) {
        this.searchField = document.querySelector(searchField);
        if (!this.searchField) return;

        const filterContentWrapper = this.searchField.parentNode;
        const filterWrapper        = filterContentWrapper?.parentNode;
        const toggleBtn            = filterWrapper?.querySelector('h2');
        const listParent           = filterContentWrapper?.querySelector('.filter-content-wrapper .filter-content-inner');

        this.listParent       = listParent;
        this.toggleBtn        = toggleBtn || null;
        this.noResultsElement = filterContentWrapper?.querySelector('.no-results-found') || null;
        this.expandBtn        = listParent?.querySelector('.facet-expand') || null;
        this.collapseBtn      = listParent?.querySelector('.facet-collapse') || null;
        this.listItems        = listParent ? Array.from(listParent.querySelectorAll('ul > li')) : [];
        this.expanded         = false;
        this.dataFacet        = this.expandBtn?.dataset.facet || null;

        this.initEventListeners();
        this.resetState();
    }

    /**
     * Initialize event listeners for the search field and expand/collapse buttons.
     */
    initEventListeners() {
        if (this.expandBtn) this.expandBtn.addEventListener('click', () => this.setExpanded(true));
        if (this.collapseBtn) this.collapseBtn.addEventListener('click', () => this.setExpanded(false));
        if (this.searchField) this.searchField.addEventListener('input', () => this.handleInput());
        if (this.toggleBtn) this.toggleBtn.addEventListener('click', () => this.setFilterExpanded());
    }

    /**
     * Normalize a value by converting it to a string, trimming whitespace, and converting to lowercase.
     * @param value
     * @returns {string}
     */
    normalize(value) {
        const s = (value === null || value === undefined) ? '' : String(value);

        return s.trim().toLowerCase();
    }

    /**
     * Handle input events on the search field with a debounce mechanism to optimize performance.
     */
    handleInput() {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            const query = this.normalize(this.searchField.value);

            query.length > 0 ? this.applySearch(query) : this.resetState();
        }, 10);
    }

    setFilterExpanded() {
        setTimeout(() => {
            this.searchField.value = '';
            this.resetState();
        }, 1000);
    }

    /**
     * Set the expanded state of the filter and reset the state of the list items accordingly.
     * @param expanded
     */
    setExpanded(expanded) {
        this.expanded = !!expanded;
        this.resetState();
    }

    /**
     * Apply the search query to filter the list items based on their text content.
     * @param query
     */
    applySearch(query) {
        this.toggleButtons(false, false);
        const searchQuery = String(query).toLowerCase();

        let visibleCount = 0;
        this.listItems.forEach(item => {
            if (!item || !item.style) return;

            const text = this.getItemText(item);
            const isVisible = text.indexOf(searchQuery) !== -1;
            item.style.display = isVisible ? 'block' : 'none';
            if (isVisible) visibleCount++;
        });

        this.noResultsElement?.classList.toggle('d-none', visibleCount !== 0);
    }

    /**
     * Reset the state of the list items based on the expanded state and facet filtering.
     */
    resetState() {
        const listItems = Array.isArray(this.listItems) ? this.listItems : [];

        this.noResultsElement?.classList.add('d-none');

        if (this.expanded) {
            this.toggleButtons(false, true);
            for (let i = 0; i < listItems.length; i++) {
                const item = listItems[i];
                if (item && item.style) item.style.display = 'block';
            }
            return;
        }

        this.toggleButtons(true, false);
        for (let i = 0; i < listItems.length; i++) {
            const item = listItems[i];
            if (item && item.style) {
                item.style.display = this.shouldHideByFacet(item) ? 'none' : 'block';
            }
        }
    }

    /**
     * Toggle the visibility of the expand and collapse buttons based on the current state.
     * @param showExpand
     * @param showCollapse
     */
    toggleButtons(showExpand, showCollapse) {
        if (this.expandBtn && this.expandBtn.style) this.expandBtn.style.display = showExpand ? '' : 'none';
        if (this.collapseBtn && this.collapseBtn.style) this.collapseBtn.style.display = showCollapse ? '' : 'none';
    }

    /**
     * Get the text content of a list item, prioritizing anchor text, then checkbox label, and finally the item itself.
     * @param item
     * @returns {string}
     */
    getItemText(item) {
        if (!item) return '';

        const anchor = item.querySelector('a');
        const checkboxLabel = item.querySelector('div.niceCheckbox .checkbox-text-label span:first-of-type');
        const element = anchor || checkboxLabel || item;
        const rawText = element ? element.textContent : '';

        return this.normalize(rawText);
    }

    /**
     * Should determine if a list item should be hidden based on its facet class and the current state of the expand button.
     * @param item
     * @returns {boolean}
     */
    shouldHideByFacet(item) {
        if (!this.expandBtn || !this.dataFacet || !item || !item.classList) return false;

        return item.classList.contains('facet-' + this.dataFacet) && this.expandBtn.style.display !== 'none';
    }
}
